import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigateHelper';

const NavigationSetup: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log('NavigateSetup');
    setNavigate(navigate);
  }, [navigate]);

  return null;
};

export default NavigationSetup;
